/* ==========================================================
   TAC DRAFTS
   Tus Álbum Cool
   Shopify Customizer ↔ Cloudflare Worker ↔ D1
   ========================================================== */

const TAC_DRAFT_PRODUCT_HANDLE =
  String(
    window
      .TAC_SHOPIFY_CONFIG
      ?.productHandle ||
    ""
  )
    .trim()
    .toLowerCase();




/* ==========================================================
   TAC DRAFT CLIENT
   Shopify Customizer ↔ Cloudflare Worker ↔ D1
   v1
   ========================================================== */

const TAC_DRAFT_API_PRODUCTION =
  "https://tac-files-api.uralbum-cool.workers.dev";

const TAC_DRAFT_API_STAGING =
  "https://tac-files-api-staging.uralbum-cool.workers.dev";

const TAC_DEVELOPMENT_THEME_ID =
  "160813744175";

const TAC_UPDATE_2_THEME_ID =
  "160913031215";

const TAC_UPDATE_3_THEME_ID =
  "160972636207";

const TAC_UPDATE_3C_THEME_ID =
  "161038008367";

const TAC_UPDATE_3C_FRIENDSHIP_THEME_ID =
  "155071873185";

const TAC_DRAFT_API = (() => {

  const hostname =
    String(window.location?.hostname || "").toLowerCase();

  const search =
    String(window.location?.search || "");

  const isLocalDevelopment =
    ["127.0.0.1", "localhost"].includes(
      hostname
    );

  const requestedEnvironment =
    search
      .match(/(?:^|[?&])tac_draft_api=([^&]+)/)?.[1];

  const themeRuntime =
    window.TAC_THEME_RUNTIME || {};

  const experienceRuntimeApi =
    String(window.TAC_3C_ADOPTION_RUNTIME?.api_base_url || "").replace(/\/+$/, "");

  if ([TAC_DRAFT_API_PRODUCTION, TAC_DRAFT_API_STAGING].includes(experienceRuntimeApi)) {
    return experienceRuntimeApi;
  }

  const isDevelopmentThemePreview =
    (
      [
      "kpzvye-at.myshopify.com",
      "tac-staging-gpdejtso.myshopify.com",
      "tusalbumcool.com",
      "www.tusalbumcool.com"
      ].includes(hostname) || hostname.endsWith(".shopifypreview.com")
    ) &&
    [TAC_DEVELOPMENT_THEME_ID, TAC_UPDATE_2_THEME_ID, TAC_UPDATE_3_THEME_ID, TAC_UPDATE_3C_THEME_ID, TAC_UPDATE_3C_FRIENDSHIP_THEME_ID].includes(String(themeRuntime.id || "")) &&
    ["development", "unpublished"].includes(String(themeRuntime.role || "").toLowerCase());

  return isDevelopmentThemePreview ||
    (requestedEnvironment === "staging" && isLocalDevelopment)
    ? TAC_DRAFT_API_STAGING
    : TAC_DRAFT_API_PRODUCTION;

})();

window.TACTrace?.("API_BASE_RESOLVED", {
  environment: TAC_DRAFT_API === TAC_DRAFT_API_STAGING ? "staging" : "production"
});

function tacDraftAnnotateError(error, stage, kind = "initialization") {
  const normalized = error instanceof Error ? error : new Error(String(error || "unknown_error"));
  normalized.tacStage ||= stage;
  normalized.tacKind ||= kind;
  return normalized;
}


const TAC_DRAFT_STORAGE_KEY =
  "tac:draft-session:v1:" +
  String(TAC_DRAFT_PRODUCT_HANDLE || "")
    .trim()
    .toLowerCase();

const TAC_FALLBACK_SESSION_KEY =
  "tac:human-verification-session:v1";

const TAC_TURNSTILE_PRIMARY_WINDOW_MS =
  12000;


window.tacDraftClient =
  window.tacDraftClient || {

    apiBaseUrl:
      TAC_DRAFT_API,

    session:
      null,

    initPromise:
      null,

    config:
      null,

    experience:
      null,

    turnstileWidgetId:
      null,


    /* =========================
       AUTOSAVE
       ========================= */

    currentStepKey:
      "portada",

    saveState:
      "clean",

    saveTimer:
      null,

    retryTimer:
      null,

    savePromise:
      null,

    saveQueued:
      false,

    lastSavedFingerprint:
      null,

    lastError:
      null,


    /*
      Configuración que sabemos
      que existe actualmente en D1.
    */

    serverConfiguration:
      {},


    /*
      IMPORTANTE:

      Si recuperamos un draft que YA
      contiene configuración, no debemos
      sobrescribirla con una UI todavía
      vacía antes de completar la hidratación.

      Por eso este switch puede bloquear
      temporalmente autosave.
    */

    hydrationReady:
      false,

    wasRestored:
      false

  };
  


/* ==========================================================
   STORAGE
   ========================================================== */

function tacDraftReadStoredSession() {

  try {

    const raw = window.TAC_CUSTOMIZER_ROUTE === "prepaid"
      ? (typeof sessionStorage !== "undefined" ? sessionStorage.getItem("tac:prepaid-design-session:v1:" + TAC_DRAFT_PRODUCT_HANDLE) : null)
      : localStorage.getItem(TAC_DRAFT_STORAGE_KEY);

    if (!raw) {
      return null;
    }


    const parsed =
      JSON.parse(raw);


    if (
      !parsed?.id ||
      !parsed?.token
    ) {

      localStorage.removeItem(
        TAC_DRAFT_STORAGE_KEY
      );

      return null;

    }

    if (
      parsed.product_handle &&
      String(parsed.product_handle).trim().toLowerCase() !==
        TAC_DRAFT_PRODUCT_HANDLE
    ) {

      localStorage.removeItem(
        TAC_DRAFT_STORAGE_KEY
      );

      return null;

    }


    return parsed;


  } catch (error) {

    console.warn(
      "[TAC Draft] No se pudo leer localStorage",
      error
    );


    return null;

  }

}


function tacDraftStoreSession(
  session
) {

  try {

    if (session.access_mode === "prepaid") {
      if (typeof sessionStorage === "undefined") throw new Error("prepaid_session_storage_unavailable");
      sessionStorage.setItem("tac:prepaid-design-session:v1:" + TAC_DRAFT_PRODUCT_HANDLE, JSON.stringify({
        id: session.id, token: session.token, revision: session.revision, material_version: session.material_version,
        claim_version: session.claim_version, expires_at: session.expires_at,
        product_handle: TAC_DRAFT_PRODUCT_HANDLE, access_mode: "prepaid"
      }));
      return;
    }

    localStorage.setItem(
      TAC_DRAFT_STORAGE_KEY,
      JSON.stringify({

        id:
          session.id,

        token:
          session.token,

        product_handle:
          TAC_DRAFT_PRODUCT_HANDLE

      })
    );


  } catch (error) {

    console.warn(
      "[TAC Draft] No se pudo guardar localStorage",
      error
    );

  }

}


function tacDraftClearSession() {

  window.tacDraftClient.session =
    null;


  try {

    localStorage.removeItem(
      TAC_DRAFT_STORAGE_KEY
    );

  } catch (error) {}

}


/* ==========================================================
   API CONFIG
   ========================================================== */

async function tacDraftGetConfig() {

  if (
    window.tacDraftClient.config
  ) {

    return window
      .tacDraftClient
      .config;

  }


  window.TACTrace?.("BEFORE_CONFIG_FETCH");
  let response;
  try {
    const request = fetch(
      TAC_DRAFT_API +
      "/v1/config",
      {
        method:
          "GET",

        headers: {
          Accept:
            "application/json"
        }
      }
    );
    window.TACTrace?.("CONFIG_FETCH_SENT");
    response = await request;
  } catch (error) {
    throw tacDraftAnnotateError(error, "CONFIG_FETCH", "network");
  }


  if (!response.ok) {

    throw new Error(
      "draft_config_" +
      response.status
    );

  }


  const config =
    await response.json();


  if (!config?.ok) {

    throw new Error(
      "draft_config_invalid"
    );

  }


  const configuredApiBase =
    String(config.api_base_url || "")
      .replace(/\/+$/, "");

  let parsedApiBase;

  try {

    parsedApiBase =
      new URL(configuredApiBase);

  } catch {

    throw new Error(
      "draft_config_api_base_invalid"
    );

  }


  if (
    !configuredApiBase ||
    parsedApiBase.protocol !== "https:" ||
    parsedApiBase.origin !== configuredApiBase ||
    configuredApiBase !== TAC_DRAFT_API
  ) {

    throw new Error(
      "draft_config_api_base_invalid"
    );

  }


  window.tacDraftClient.config =
    config;

  window.TACTrace?.("CONFIG_FETCH_OK", {
    environment: String(config.environment || "unknown")
  });


  return config;

}


const TAC_TURNSTILE_SCRIPT_URL =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

let tacDraftTurnstileLoadPromise = null;
let tacDraftTurnstileInstanceSequence = 0;
let tacDraftActiveTurnstileInstance = null;


/* ==========================================================
   TURNSTILE LOADER
   ========================================================== */

function tacDraftLoadTurnstile() {

  window.TACTrace?.("TURNSTILE_SCRIPT_START");

  if (
    window.turnstile
  ) {

    window.TACTrace?.("TURNSTILE_SCRIPT_READY", { source: "existing" });
    return Promise.resolve();

  }


  if (tacDraftTurnstileLoadPromise) {
    return tacDraftTurnstileLoadPromise;
  }

  tacDraftTurnstileLoadPromise = new Promise((resolve, reject) => {
    const exactScript = document.querySelector(
      'script[src="' + TAC_TURNSTILE_SCRIPT_URL + '"]'
    );
    const conflictingScript = document.querySelector(
      'script[src*="challenges.cloudflare.com/turnstile/v0/api.js"]'
    );

    if (conflictingScript && !exactScript) {
      reject(new Error("turnstile_script_conflict"));
      return;
    }

    const script = exactScript || document.createElement("script");
    const source = exactScript ? "pending-script" : "new-script";
    let settled = false;
    let timer = null;

    const finish = error => {
      if (settled) return;
      settled = true;
      if (timer !== null) clearTimeout(timer);
      script.removeEventListener?.("load", onLoad);
      script.removeEventListener?.("error", onError);

      if (error) {
        reject(error);
        return;
      }

      if (!window.turnstile) {
        reject(new Error("turnstile_load_failed"));
        return;
      }

      window.TACTrace?.("TURNSTILE_SCRIPT_READY", { source });
      resolve();
    };
    const onLoad = () => finish(null);
    const onError = () => finish(new Error("turnstile_load_failed"));

    script.addEventListener("load", onLoad, { once: true });
    script.addEventListener("error", onError, { once: true });
    timer = setTimeout(
      () => finish(new Error("turnstile_load_failed")),
      10000
    );

    if (!exactScript) {
      script.src = TAC_TURNSTILE_SCRIPT_URL;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  });

  return tacDraftTurnstileLoadPromise;
}


function tacDraftHideTurnstilePresentation(container = null) {
  const target =
    container ||
    tacDraftActiveTurnstileInstance?.container ||
    document.getElementById("tac-draft-turnstile");
  if (!target) return;

  target.className = "tac-turnstile-container";
  target.dataset.tacTurnstileInteractive = "false";
  target.setAttribute("aria-hidden", "true");
  Object.assign(target.style, {
    width: "",
    height: "",
    minHeight: "",
    maxWidth: "",
    padding: "0",
    margin: "0",
    display: "block",
    alignItems: "",
    justifyContent: "",
    background: "transparent",
    border: "0",
    borderRadius: "0",
    boxShadow: "none",
    opacity: "0",
    visibility: "hidden",
    pointerEvents: "none"
  });
}


function tacDraftStartFreshSession() {
  tacDraftClearSession();
  const client = window.tacDraftClient;
  clearTimeout(client.saveTimer);
  clearTimeout(client.retryTimer);
  client.initPromise = null;
  client.hydrationPromise = null;
  client.hydrationReady = false;
  client.hydratedDraftId = null;
  client.serverConfiguration = {};
  client.currentStepKey = "portada";
  client.wasRestored = false;
  client.finalization = null;
  client.finalizationResult = null;
  client.saveState = "clean";
  client.savePromise = null;
  client.saveQueued = false;
  client.lastSavedFingerprint = null;
  client.lastError = null;
}


window.TACStartFreshDraftSession = tacDraftStartFreshSession;


function tacDraftShowTurnstilePresentation(container) {
  if (!container) return;

  container.className = "tac-turnstile-container tac-turnstile-container--interactive";
  container.dataset.tacTurnstileInteractive = "true";
  container.setAttribute("aria-hidden", "false");
  Object.assign(container.style, {
    width: "min(320px, calc(100vw - 24px))",
    height: "auto",
    minHeight: "81px",
    maxWidth: "calc(100vw - 24px)",
    padding: "8px",
    margin: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    border: "1px solid rgba(17, 17, 17, 0.14)",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.16)",
    opacity: "1",
    visibility: "visible",
    pointerEvents: "auto"
  });
}


window.TACHideTurnstilePresentation = tacDraftHideTurnstilePresentation;


function tacDraftCreateTurnstileContainer() {
  const staleContainer = document.getElementById("tac-draft-turnstile");
  if (staleContainer?.isConnected) staleContainer.remove();

  const container = document.createElement("div");
  container.id = "tac-draft-turnstile";
  container.setAttribute("role", "region");
  container.setAttribute("aria-label", "Security verification");

  Object.assign(container.style, {
    position: "fixed",
    left: "50%",
    bottom: "90px",
    transform: "translateX(-50%)",
    boxSizing: "border-box",
    overflow: "visible",
    zIndex: "2147483647"
  });
  tacDraftHideTurnstilePresentation(container);

  document.body.appendChild(container);
  return container;
}


/* ==========================================================
   TURNSTILE TOKEN
   ========================================================== */

async function tacDraftGetTurnstileToken() {

  const config =
    await tacDraftGetConfig();

  window.TACTrace?.("TURNSTILE_INIT");

  await tacDraftLoadTurnstile();


  const runAttempt = attempt => new Promise((resolve, reject) => {
    if (tacDraftActiveTurnstileInstance?.state === "active") {
      tacDraftActiveTurnstileInstance.cancel(
        tacDraftAnnotateError(new Error("turnstile_instance_replaced"), "TURNSTILE_TOKEN")
      );
    }

    tacDraftTurnstileInstanceSequence += 1;
    const instance = {
      instanceId: "tac-ts-" + tacDraftTurnstileInstanceSequence,
      attempt,
      state: "active",
      widgetId: null,
      container: tacDraftCreateTurnstileContainer(),
      timer: null,
      widgetRemoved: false,
      containerRemoved: false,
      cleaned: false
    };

    tacDraftActiveTurnstileInstance = instance;

    const isCurrent = () =>
      tacDraftActiveTurnstileInstance === instance &&
      instance.state === "active" &&
      instance.cleaned === false &&
      instance.container.isConnected === true &&
      instance.widgetId !== null &&
      instance.widgetId !== undefined &&
      window.tacDraftClient.turnstileWidgetId === instance.widgetId;

    const cleanup = () => {
      if (instance.cleaned) return;
      instance.cleaned = true;
      tacDraftHideTurnstilePresentation(instance.container);

      if (instance.timer !== null) {
        clearTimeout(instance.timer);
        instance.timer = null;
      }

      if (!instance.widgetRemoved && instance.widgetId !== null && instance.widgetId !== undefined) {
        instance.widgetRemoved = true;
        try {
          window.turnstile.remove(instance.widgetId);
        } catch (error) {}
      }

      if (!instance.containerRemoved) {
        instance.containerRemoved = true;
        if (instance.container.isConnected) instance.container.remove();
      }

      if (window.tacDraftClient.turnstileWidgetId === instance.widgetId) {
        window.tacDraftClient.turnstileWidgetId = null;
      }
      if (tacDraftActiveTurnstileInstance === instance) {
        tacDraftActiveTurnstileInstance = null;
      }
      instance.state = "cleaned";
    };

    const finish = (type, value) => {
      if (!isCurrent()) return;
      instance.state = "settled";
      cleanup();
      if (type === "resolve") resolve(value);
      else reject(value);
    };

    instance.cancel = error => {
      if (instance.state !== "active") return;
      instance.state = "settled";
      cleanup();
      reject(error || tacDraftAnnotateError(new Error("turnstile_cancelled"), "TURNSTILE_TOKEN"));
    };

    (async () => {
      const appearance = "interaction-only";
      window.TACTrace?.("TURNSTILE_RENDER_START", { attempt, appearance });
      instance.widgetId = window.turnstile.render(instance.container, {
        sitekey: config.turnstile.site_key,
        action: config.turnstile.action,
        appearance,
        execution: "render",
        size: "flexible",
        retry: "auto",
        "retry-interval": 3000,
        "refresh-expired": "auto",
        "refresh-timeout": "auto",
        "response-field": false,
        language: String(window.tacLang || "auto"),
        theme: "light",
        callback: token => {
          if (!isCurrent()) return;
          tacDraftHideTurnstilePresentation(instance.container);
          window.TACTrace?.("TURNSTILE_CALLBACK", { attempt });
          if (!token) {
            finish("reject", tacDraftAnnotateError(new Error("turnstile_empty_token"), "TURNSTILE_TOKEN"));
            return;
          }
          window.TACTrace?.("TURNSTILE_TOKEN_RECEIVED", { attempt });
          finish("resolve", token);
        },
        "error-callback": code => {
          if (!isCurrent()) return;
          tacDraftHideTurnstilePresentation(instance.container);
          window.TACTrace?.("TURNSTILE_ERROR_CALLBACK", { attempt, code: String(code || "unknown") });
          return false;
        },
        "timeout-callback": () => {
          if (!isCurrent()) return;
          tacDraftHideTurnstilePresentation(instance.container);
          window.TACTrace?.("TURNSTILE_TIMEOUT_CALLBACK", { attempt, source: "widget" });
        },
        "before-interactive-callback": () => {
          if (!isCurrent()) return;
          tacDraftShowTurnstilePresentation(instance.container);
          window.TACTrace?.("TURNSTILE_INTERACTION_REQUIRED", { attempt });
        },
        "after-interactive-callback": () => {
          if (!isCurrent()) return;
          tacDraftHideTurnstilePresentation(instance.container);
          window.TACTrace?.("TURNSTILE_INTERACTION_FINISHED", { attempt });
        },
        "expired-callback": () => {
          if (!isCurrent()) return;
          tacDraftHideTurnstilePresentation(instance.container);
          finish("reject", tacDraftAnnotateError(new Error("turnstile_token_expired"), "TURNSTILE_TOKEN"));
        },
        "unsupported-callback": () => {
          if (!isCurrent()) return;
          tacDraftHideTurnstilePresentation(instance.container);
          window.TACTrace?.("TURNSTILE_ERROR_CALLBACK", { attempt, code: "unsupported_browser" });
          finish("reject", tacDraftAnnotateError(new Error("turnstile_unsupported_browser"), "TURNSTILE_TOKEN"));
        }
      });
      window.tacDraftClient.turnstileWidgetId = instance.widgetId;
      window.TACTrace?.("TURNSTILE_RENDER_OK", { attempt });

      instance.timer = setTimeout(() => {
        if (!isCurrent()) return;
        tacDraftHideTurnstilePresentation(instance.container);
        window.TACTrace?.("TURNSTILE_TIMEOUT_CALLBACK", { attempt, source: "client-timer" });
        finish("reject", tacDraftAnnotateError(new Error("turnstile_timeout"), "TURNSTILE_TOKEN", "initialization"));
      }, 120000);
    })().catch(error => {
      if (instance.state === "active") {
        instance.cancel(tacDraftAnnotateError(error, "TURNSTILE_RENDER"));
      }
    });
  });

  let lastError;
  for (let attempt = 1; attempt <= 2; attempt += 1) {
    try {
      return await runAttempt(attempt);
    } catch (error) {
      lastError = error;
      if (attempt === 2 || error?.message === "turnstile_unsupported_browser") break;
    }
  }

  throw lastError || tacDraftAnnotateError(new Error("turnstile_failed"), "TURNSTILE_TOKEN");

}


function tacDraftBase64Url(bytes) {
  let value = "";
  bytes.forEach(byte => { value += String.fromCharCode(byte); });
  return btoa(value)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
}


function tacDraftGetFallbackSessionId() {
  try {

    if (typeof sessionStorage !== "undefined") sessionStorage.removeItem("tac:prepaid-design-session:v1:" + TAC_DRAFT_PRODUCT_HANDLE);
    const stored = localStorage.getItem(TAC_FALLBACK_SESSION_KEY);
    if (/^[A-Za-z0-9_-]{32,96}$/.test(String(stored || ""))) return stored;
  } catch (error) {}

  const sessionId = tacDraftBase64Url(
    crypto.getRandomValues(new Uint8Array(24))
  );

  try {
    localStorage.setItem(TAC_FALLBACK_SESSION_KEY, sessionId);
  } catch (error) {}

  return sessionId;
}


function tacDraftLeadingZeroBits(bytes) {
  let bits = 0;
  for (const byte of bytes) {
    if (byte === 0) {
      bits += 8;
      continue;
    }
    bits += Math.clz32(byte) - 24;
    break;
  }
  return bits;
}


async function tacDraftSolveFallbackPow(challenge, requiredBits) {
  const encoder = new TextEncoder();
  const bits = Math.max(8, Math.min(20, Number(requiredBits) || 12));

  for (let counter = 0; counter <= 5000000; counter += 1) {
    const digest = new Uint8Array(
      await crypto.subtle.digest(
        "SHA-256",
        encoder.encode(challenge + "." + counter)
      )
    );

    if (tacDraftLeadingZeroBits(digest) >= bits) return counter;
    if (counter > 0 && counter % 256 === 0) {
      await new Promise(resolve => setTimeout(resolve, 0));
    }
  }

  throw tacDraftAnnotateError(
    new Error("fallback_proof_failed"),
    "FALLBACK_PROOF"
  );
}


async function tacDraftGetFallbackAuthorization() {
  const config = await tacDraftGetConfig();
  if (config.human_verification?.fallback_enabled !== true) {
    throw tacDraftAnnotateError(
      new Error("fallback_unavailable"),
      "FALLBACK_CHALLENGE"
    );
  }

  const sessionId = tacDraftGetFallbackSessionId();
  const request = async (path, body) => {
    const response = await fetch(TAC_DRAFT_API + path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(body)
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || result.ok !== true) {
      throw tacDraftAnnotateError(
        new Error("fallback_verification_failed"),
        "FALLBACK_VERIFICATION"
      );
    }
    return result;
  };

  window.TACTrace?.("FALLBACK_CHALLENGE_START");
  const issued = await request(
    "/v1/human-verification/fallback/challenge",
    {
      session_id: sessionId,
      product_handle: TAC_DRAFT_PRODUCT_HANDLE
    }
  );

  const counter = await tacDraftSolveFallbackPow(
    issued.challenge,
    issued.pow_bits
  );

  const waitMilliseconds = Math.max(
    0,
    Number(issued.not_before || 0) * 1000 - Date.now()
  );
  if (waitMilliseconds > 0) {
    await new Promise(resolve => setTimeout(resolve, waitMilliseconds));
  }

  const verified = await request(
    "/v1/human-verification/fallback/verify",
    {
      session_id: sessionId,
      product_handle: TAC_DRAFT_PRODUCT_HANDLE,
      challenge: issued.challenge,
      counter
    }
  );

  tacDraftHideTurnstilePresentation();
  window.TACTrace?.("FALLBACK_TOKEN_RECEIVED");
  return {
    fallback_token: verified.fallback_token,
    fallback_session_id: sessionId
  };
}


async function tacDraftGetHumanAuthorization() {
  let deadlineId = null;
  const deadline = new Promise((resolve, reject) => {
    deadlineId = setTimeout(
      () => {
        tacDraftHideTurnstilePresentation();
        reject(tacDraftAnnotateError(new Error("turnstile_primary_window_elapsed"), "TURNSTILE_TOKEN"));
      },
      TAC_TURNSTILE_PRIMARY_WINDOW_MS
    );
  });

  const turnstileAttempt = tacDraftGetTurnstileToken();

  try {
    const token = await Promise.race([turnstileAttempt, deadline]);
    clearTimeout(deadlineId);
    return { turnstile_token: token };
  } catch (error) {
    clearTimeout(deadlineId);
    tacDraftHideTurnstilePresentation();
    if (tacDraftActiveTurnstileInstance?.state === "active") {
      tacDraftActiveTurnstileInstance.cancel(
        tacDraftAnnotateError(new Error("turnstile_fallback_selected"), "TURNSTILE_TOKEN")
      );
    }
    turnstileAttempt.catch(() => {});
    window.TACTrace?.("FALLBACK_SELECTED", {
      reason: String(error?.message || "turnstile_unavailable")
    });
    tacDraftHideTurnstilePresentation();
    return tacDraftGetFallbackAuthorization();
  }
}


/* ==========================================================
   RECUPERAR UN DRAFT EXISTENTE
   ========================================================== */

async function tacDraftRestoreStoredSession() {

  const prepaidSession = await (window.TACPrepaidReady || Promise.resolve(null));
  if (window.TAC_CUSTOMIZER_ROUTE === "prepaid" &&
      (!prepaidSession?.id || !prepaidSession?.token || !window.TAC_PREPAID_ACTIVE)) {
    throw new Error("prepaid_channel_not_authorized");
  }

  const stored =
    tacDraftReadStoredSession();


  if (!stored) {

    return null;

  }


  try {

    const response =
      await fetch(
        TAC_DRAFT_API +
        "/v1/drafts/" +
        encodeURIComponent(
          stored.id
        ),
        {

          method:
            "GET",

          headers: {

            Authorization:
              "Bearer " +
              stored.token,

            Accept:
              "application/json"

          }

        }
      );

    let result = {};
    try {
      result = await response.json();
    } catch (error) {}

    if (result?.draft && result.draft.access_mode !== (window.TAC_CUSTOMIZER_ROUTE === "prepaid" ? "prepaid" : "shopify")) {
      throw new Error("draft_channel_mismatch");
    }
    if (!response.ok && window.TAC_CUSTOMIZER_ROUTE === "prepaid") {
      throw new Error("prepaid_session_not_authorized");
    }

    if (
      response.status === 409 &&
      ["finalizing", "ordered"].includes(result?.status) &&
      window.TACFinalization?.resolveStored
    ) {
      const terminalSession = {
        id: stored.id,
        token: stored.token,
        revision: Number(stored.revision || 1),
        expires_at: stored.expires_at || null,
        status: result.status
      };
      window.tacDraftClient.session = terminalSession;
      tacDraftStoreSession(terminalSession);
      const resolution = await window.TACFinalization.resolveStored(terminalSession, { goToCart: true });
      if (resolution?.action === "start_over") {
        tacDraftStartFreshSession();
        return null;
      }
      if (resolution?.action === "cancel") {
        window.tacDraftClient.session = null;
        window.tacDraftClient.finalization = null;
        window.tacDraftClient.finalizationResult = null;
        window.tacDraftClient.hydrationReady = false;
        window.TACCloseCustomizer?.();
      }
      const handled = new Error("finalized_draft_handled");
      handled.tacTerminalHandled = true;
      throw handled;
    }

    /*
      Draft inválido, expirado,
      borrado o token incorrecto.
    */

    if (
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 410
    ) {

      tacDraftClearSession();

      return null;

    }


    if (!response.ok) {

      throw new Error(
        "draft_restore_" +
        response.status
      );

    }


    if (
      !result?.ok ||
      !result?.draft?.id
    ) {

      tacDraftClearSession();

      return null;

    }

    if (
      String(result.draft.product_handle || "").trim().toLowerCase() !==
        TAC_DRAFT_PRODUCT_HANDLE
    ) {

      tacDraftClearSession();

      return null;

    }


    window.tacDraftClient.experience =
      window.TACProductExperience?.acceptDraftExperience?.(
        result.experience || null
      ) || null;

    const session = {

      id:
        result.draft.id,

      token:
        stored.token,

      revision:
        Number(
          result.draft.revision ||
          stored.revision ||
          1
        ),

      expires_at:
        result.draft.expires_at ||
        stored.expires_at ||
        null,

      access_mode:
        result.draft.access_mode,
      ...(result.draft.access_mode === "prepaid" ? {
        material_version: Number(result.draft.material_version || 0),
        ...(Number.isInteger(prepaidSession?.claim_version) ? {claim_version: prepaidSession.claim_version} : {})
      } : {})

    };


    window
      .tacDraftClient
      .session =
        session;


    tacDraftStoreSession(
      session
    );

const existingConfiguration =
  (
    result.draft.configuration &&
    typeof result.draft.configuration ===
      "object" &&
    !Array.isArray(
      result.draft.configuration
    )
  )
    ? result.draft.configuration
    : {};


window
  .tacDraftClient
  .serverConfiguration =
    existingConfiguration;


window
  .tacDraftClient
  .currentStepKey =
    result.draft.current_step_key ||
    "portada";


window
  .tacDraftClient
  .wasRestored =
    true;


window.tacDraftClient.hydrationReady = false;

    console.log(
      "[TAC Draft] ♻️ Recuperado:",
      session.id
    );


    return session;


  } catch (
    error
  ) {

    if (error?.tacTerminalHandled) throw error;

    /*
      IMPORTANTE:

      Si hay un simple problema
      temporal de internet NO borramos
      la sesión existente.
    */

    console.warn(
      "[TAC Draft] No se pudo comprobar el draft guardado",
      error
    );


    throw error;

  }

}


/* ==========================================================
   CREAR DRAFT NUEVO
   ========================================================== */

async function tacDraftCreate() {

  if (window.TAC_CUSTOMIZER_ROUTE === "prepaid") throw new Error("prepaid_native_create_forbidden");

  const experienceAdoption =
    await (window.TACProductExperience?.prepareDraftCreation?.() || Promise.resolve(null));

  const humanAuthorization =
    await tacDraftGetHumanAuthorization();


  const response =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts",
      {

        method:
          "POST",

        headers: {

          "Content-Type":
            "application/json",

          Accept:
            "application/json"

        },

        body:
          JSON.stringify({

            ...humanAuthorization,

            product_handle:
              TAC_DRAFT_PRODUCT_HANDLE,

            current_step_key:
              "portada",

            configuration: {},

            locale:
              String(
                window.tacLang ||
                "es"
              ),

            currency:
              String(
                window
                  .TAC_ADDONS
                  ?.currency ||
                "MXN"
              ),

            country_code:
  window
    .TAC_SHOPIFY_CONFIG
    ?.countryCode ||
  "MX",

            ...(experienceAdoption
              ? { experience_adoption: experienceAdoption }
              : {})

          })

      }
    );


  const result =
    await response.json();


  if (
    !response.ok ||
    !result?.ok ||
    !result?.draft?.id ||
    !result?.draft?.token
  ) {

    throw new Error(
      result?.error ||
      (
        "draft_create_" +
        response.status
      )
    );

  }


  const session = {

    id:
      result.draft.id,

    // The native create endpoint only issues Shopify drafts (D1 enforces the channel).
    access_mode: "shopify",

    token:
      result.draft.token,

    revision:
      Number(
        result.draft.revision ||
        1
      ),

    expires_at:
      result.draft.expires_at ||
      null

  };

  window.tacDraftClient.experience =
    window.TACProductExperience?.acceptDraftExperience?.(
      result.experience || null
    ) || null;

  window
  .tacDraftClient
  .serverConfiguration =
    {};


window
  .tacDraftClient
  .currentStepKey =
    result.draft.current_step_key ||
    "portada";


window
  .tacDraftClient
  .wasRestored =
    false;


window
  .tacDraftClient
  .hydrationReady =
    false;

  window
    .tacDraftClient
    .session =
      session;


  tacDraftStoreSession(
    session
  );


  console.log(
    "[TAC Draft] ✨ Creado:",
    session.id
  );


  return session;

}


/* ==========================================================
   ENSURE SESSION

   Esta es la única función que el customizer
   necesita llamar.
   ========================================================== */

async function tacEnsureDraftSession() {

  if (
    window
      .tacDraftClient
      .session
      ?.id
  ) {

    tacDraftHideTurnstilePresentation();
    window.TACTrace?.("DRAFT_INIT_OK", { source: "memory" });

    return window
      .tacDraftClient
      .session;

  }


  /*
    Evita dos POST simultáneos si el usuario
    hace doble click o algún evento se dispara
    dos veces.
  */

  if (
    window
      .tacDraftClient
      .initPromise
  ) {

    return window
      .tacDraftClient
      .initPromise;

  }


  window
    .tacDraftClient
    .initPromise =
      (
        async () => {

          window.TACTrace?.("DRAFT_INIT_START");

          const [, restored] = await Promise.all([
            tacDraftGetConfig(),
            tacDraftRestoreStoredSession()
          ]);


          if (restored) {

            tacDraftHideTurnstilePresentation();
            window.TACTrace?.("DRAFT_INIT_OK", { source: "restored" });

            return restored;

          }


          const created = await tacDraftCreate();
          tacDraftHideTurnstilePresentation();
          window.TACTrace?.("DRAFT_INIT_OK", { source: "created" });
          return created;

        }
      )();


  try {

    return await window
      .tacDraftClient
      .initPromise;


  } finally {

    window
      .tacDraftClient
      .initPromise =
        null;

  }

}

/* ==========================================================
   TAC DRAFT AUTOSAVE
   Customizer → Worker → D1
   ========================================================== */


/* ----------------------------------------------------------
   CLONE JSON SEGURO
   ---------------------------------------------------------- */

function tacDraftJsonClone(
  value,
  fallback
) {

  try {

    return JSON.parse(
      JSON.stringify(
        value
      )
    );

  } catch (error) {

    return fallback;

  }

}


/* ----------------------------------------------------------
   NORMALIZAR ARRAYS DE TEXTO
   ---------------------------------------------------------- */

function tacDraftStringArray(
  value
) {

  return Array.isArray(value)
    ? value.map(
        item =>
          String(
            item ?? ""
          )
      )
    : [];

}

function tacDraftRemoteReferences(state, category) {

  return Array.isArray(state?.remotes)
    ? state.remotes.map((remote, index) => remote?.id
        ? {
            file_id: remote.id,
            category,
            position: index + 1,
            status: remote.status,
            object_key: remote.object_key || null,
            stored_size_bytes: remote.stored_size_bytes ?? null,
            etag: remote.etag || null
          }
        : null)
    : null;

}


/* ----------------------------------------------------------
   CONSTRUIR CONFIGURACIÓN PERSISTENTE

   MUY IMPORTANTE:
   aquí NO entran:
   - File
   - Blob
   - blob:
   - Object URLs

   Las fotografías se guardan por referencia remota.
   ---------------------------------------------------------- */

function tacDraftBuildConfiguration() {

  const data =
    window.tacCustomizer
      ?.data || {};


  const activeSteps =
    Array.isArray(
      window.tacCustomizer
        ?.activeSteps
    )
      ? window
          .tacCustomizer
          .activeSteps
      : [];


  /*
    Partimos de lo que ya conoce el
    servidor para no destruir campos
    futuros que todavía no manejemos.
  */

  const base =
    tacDraftJsonClone(
      window
        .tacDraftClient
        ?.serverConfiguration ||
        {},
      {}
    );


  const pricing =
    data.pricing || {};


  const puzzleReferences =
    tacDraftRemoteReferences(
      data.foto_rompecabezas,
      "puzzle"
    );


  const configuration = {

    ...base,


    schema_version:
      1,


    product_handle:
      TAC_DRAFT_PRODUCT_HANDLE,


    data: {
      ...base.data,

      portada: {
        ...base.data?.portada,

  diseno:
    data.portada
      ?.diseno ||
    null,


  frase:
    String(
      data.portada
        ?.frase || ""
    ),


  nombres:
    String(
      data.portada
        ?.nombres || ""
    ),


  fecha:
    String(
      data.portada
        ?.fecha || ""
    ),


  /*
    Referencia lógica a la foto.

    NO guardamos File,
    NO guardamos blob:,
    NO guardamos bytes en D1.
  */

  foto:
    data.portada
      ?.fotoRemote
      ?.id
      ? {

          file_id:
            data.portada
              .fotoRemote
              .id,

          category:
            "cover",

          position:
            1,

          status:
            data.portada
              .fotoRemote
              .status,

          object_key:
            data.portada
              .fotoRemote
              .object_key ||
            null,

          stored_size_bytes:
            data.portada
              .fotoRemote
              .stored_size_bytes ||
            null,

          etag:
            data.portada
              .fotoRemote
              .etag ||
            null

        }
      : (
          base
            ?.data
            ?.portada
            ?.foto ||
          null
        )

},

fotos_estampas: {
        ...base.data?.fotos_estampas,

  files:
    Array.isArray(
      data.fotos_estampas
        ?.remotes
    )
      ? data
          .fotos_estampas
          .remotes
          .map(
            (
              remote,
              index
            ) => {

              if (
                !remote?.id
              ) {

                return null;

              }


              return {

                file_id:
                  remote.id,

                category:
                  "stamps",

                position:
                  index + 1,

                status:
                  remote.status,

                object_key:
                  remote.object_key ||
                  null,

                stored_size_bytes:
                  remote
                    .stored_size_bytes ??
                  null,

                etag:
                  remote.etag ||
                  null

              };

            }
          )
      : (
          base
            ?.data
            ?.fotos_estampas
            ?.files ||
          []
        )

},

      foto_rompecabezas: {
        ...base.data?.foto_rompecabezas,

        file:
          puzzleReferences === null
            ? (
                base?.data?.foto_rompecabezas?.file ||
                null
              )
            : (
                puzzleReferences[0] ||
                null
              )

      },

      fotos_fondo: {
        ...base.data?.fotos_fondo,

        files:
          tacDraftRemoteReferences(data.fotos_fondo, "backgrounds") ||
          base?.data?.fotos_fondo?.files ||
          []

      },

      dedicatoria: {
        ...base.data?.dedicatoria,

        deParteDe:
          String(
            data.dedicatoria
              ?.deParteDe || ""
          )

      },


      texto_final: {
        ...base.data?.texto_final,

        texto:
          String(
            data.texto_final
              ?.texto || ""
          )

      },


      spotify_playlist: {
        ...base.data?.spotify_playlist,

        link:
          String(
            data.spotify_playlist
              ?.link || ""
          )

      },


      peliculas: {
        ...base.data?.peliculas,

        items:
          tacDraftStringArray(
            data.peliculas
              ?.items
          )

      },


      sopa_letras: {
        ...base.data?.sopa_letras,

        items:
          tacDraftStringArray(
            data.sopa_letras
              ?.items
          )

      },


      fecha_especial: {
        ...base.data?.fecha_especial,

        value:
          String(
            data.fecha_especial
              ?.value || ""
          )

      },


      spotify_codigos: {
        ...base.data?.spotify_codigos,

        canciones:
          tacDraftStringArray(
            data.spotify_codigos
              ?.canciones
          )

      },


      fotos_con_texto: {
        ...base.data?.fotos_con_texto,

        files:
          tacDraftRemoteReferences(data.fotos_con_texto, "text_photos") ||
          base?.data?.fotos_con_texto?.files ||
          [],

        textos:
          tacDraftStringArray(
            data.fotos_con_texto
              ?.textos
          )

      }

    },


    pricing: {
      ...base.pricing,

      fotos_qty:
        pricing.fotos_qty ??
        null,

      fotos_addon_variant_id:
        pricing
          .fotos_addon_variant_id ??
        null,

      extras:
        tacDraftJsonClone(
          pricing.extras || {},
          {}
        )

    },


    /*
      Esto nos permitirá reconstruir
      después el flujo flexible y los
      AddOns elegidos.
    */

    flow: {
      ...base.flow,

      active_steps:
        tacDraftJsonClone(
          activeSteps,
          []
        )

    }

  };


  // Remove legacy physical keys as well as any accidental ephemeral preview data.
  // The active upload client may retain keys in memory for concurrency checks only.
  return JSON.parse(JSON.stringify(configuration, (key, value) => {
    if (['object_key', 'replacement_object_key', 'token', 'token_hash', 'bearer', 'preview_url', 'upload_url', 'fotoPreviewURL'].includes(key)) return undefined;
    if (typeof Blob !== 'undefined' && value instanceof Blob) return undefined;
    if (typeof value === 'string' && /^(blob:|data:)/i.test(value)) return undefined;
    return value;
  }));

}


/* ----------------------------------------------------------
   ESTADO DEL AUTOSAVE
   ---------------------------------------------------------- */

function tacDraftSetSaveState(
  state,
  error = null
) {

  const client =
    window.tacDraftClient;


  client.saveState =
    state;


  client.lastError =
    error;

  if (typeof document.dispatchEvent === "function" && typeof CustomEvent === "function") document.dispatchEvent(new CustomEvent("tac:save-state", {
    detail: { state, error }
  }));


  /*
    Después convertiremos esto
    en UI aesthetic.

    Por ahora sólo lo exponemos
    internamente.
  */

}


/* ----------------------------------------------------------
   PROGRAMAR AUTOSAVE

   Debounce: 750ms.
   ---------------------------------------------------------- */

function tacDraftScheduleSave(
  {
    immediate = false,
    reason = "change"
  } = {}
) {

  const client =
    window.tacDraftClient;


  if (!client || (client.session?.access_mode === "prepaid" && window.TACPrepaidAccess?.blocked)) {
    return;
  }


  /*
    Barrera de hidratación y conflictos.

    Nunca escribimos sobre un draft
    restaurado antes de hidratar la UI.
  */

  if (client.saveState === "conflict") {
    window.TACHydration?.preserveConflict();
    return false;
  }

  if (
    client.hydrationReady !==
      true
  ) {

    return;

  }


  tacDraftSetSaveState(
    "dirty"
  );


  clearTimeout(
    client.saveTimer
  );


  client.saveTimer =
    setTimeout(
      () => {

        tacDraftFlushSave(
          reason
        );

      },
      immediate
        ? 0
        : 750
    );

}


/*
  Review is a server-authoritative snapshot. Before requesting it, settle the
  last real edit and cancel the click-debounce that would otherwise persist a
  navigation-only current_step_key after the snapshot was issued.
*/
window.TACFlushDraftForReview = async function TACFlushDraftForReview() {
  const client = window.tacDraftClient;
  if (!client) return false;
  clearTimeout(client.saveTimer);
  client.saveTimer = null;
  if (client.session?.access_mode !== "prepaid") return tacDraftFlushSave("prepaid-review");
  // A review must drain the latest edit, not merely await the older PUT.
  for (let attempt = 0; attempt < 8; attempt += 1) {
    if (tacPrepaidFilesPending() || window.TACPrepaidAccess?.blocked) return false;
    clearTimeout(client.saveTimer); client.saveTimer = null;
    if (!await tacDraftFlushSave("prepaid-review")) return false;
    clearTimeout(client.saveTimer); client.saveTimer = null;
    if (window.TACPrepaidSaveBarrier.capture()) return true;
    if (client.saveState === "error" || client.saveState === "conflict") return false;
  }
  return false;
};


function tacDraftStableValue(value) {
  if (Array.isArray(value)) return value.map(tacDraftStableValue);
  if (!value || typeof value !== "object") return value;
  return Object.fromEntries(Object.keys(value).sort().map(key => [key, tacDraftStableValue(value[key])]));
}


function tacPrepaidContentFingerprint(configuration) {
  return JSON.stringify(tacDraftStableValue(configuration));
}

function tacPrepaidFilesPending() {
  const pool = window.TACFiles?.metrics?.() || {};
  if (pool.active || pool.waiting) return true;
  return Object.values(window.tacCustomizer?.data || {}).some(state => state && typeof state === "object" && (
    window.TACFileSlots?.pending?.(state) || state.fotoFile || state.fotoUploadError ||
    state.fotoUploadStatus === "uploading" || state.fotoUploadStatus === "error" ||
    (Array.isArray(state.files) && state.files.some(file => typeof Blob !== "undefined" && file instanceof Blob)) ||
    (Array.isArray(state.uploadStatus) && state.uploadStatus.some(value => ["queued", "uploading", "verifying", "failed"].includes(value))) ||
    (Array.isArray(state.errors) && state.errors.some(Boolean))
  ));
}

window.TACPrepaidSaveBarrier = {
  fingerprint: tacPrepaidContentFingerprint,
  matchesInventory(inventory, proof) {
    if (!Array.isArray(inventory) || !proof) return false;
    const data = JSON.parse(proof.fingerprint).data || {};
    const expected = [data.portada?.foto, ...(data.fotos_estampas?.files || []), data.foto_rompecabezas?.file,
      ...(data.fotos_con_texto?.files || []), ...(data.fotos_fondo?.files || [])].filter(Boolean);
    const normalize = files => files.map(file => [file.category, Number(file.position), file.file_id, file.etag]);
    const valid = files => files.every(file => typeof file.file_id === "string" && file.file_id &&
      typeof file.etag === "string" && file.etag && Number.isInteger(Number(file.position)) && Number(file.position) > 0);
    if (!valid(expected) || !valid(inventory) || expected.length !== inventory.length) return false;
    const unique = files => new Set(files.map(file => file.category + ":" + file.position)).size === files.length &&
      new Set(files.map(file => file.file_id)).size === files.length;
    if (!unique(expected) || !unique(inventory)) return false;
    const sort = rows => rows.sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
    return JSON.stringify(sort(normalize(expected))) === JSON.stringify(sort(normalize(inventory)));
  },
  capture() {
    const client = window.tacDraftClient, session = client?.session;
    if (!session?.id || session.access_mode !== "prepaid" || client.hydrationReady !== true ||
        window.TACPrepaidAccess?.blocked || client.savePromise || client.saveQueued ||
        !["saved", "clean"].includes(client.saveState) || tacPrepaidFilesPending()) return null;
    const fingerprint = tacPrepaidContentFingerprint(tacDraftBuildConfiguration());
    if (fingerprint !== tacPrepaidContentFingerprint(client.serverConfiguration)) return null;
    return {session, id: session.id, revision: Number(session.revision),
      materialVersion: Number(session.material_version || 0), claimVersion: Number(session.claim_version || 0), fingerprint};
  },
  matches(proof) {
    const current = this.capture();
    return Boolean(current && proof && current.session === proof.session && current.id === proof.id &&
      current.revision === proof.revision && current.materialVersion === proof.materialVersion &&
      current.claimVersion === proof.claimVersion && current.fingerprint === proof.fingerprint);
  }
};

async function tacDraftReconcileSave(session, configuration, currentStepKey) {
  const response = await tacDraftAuthorizedFetch(session,
    TAC_DRAFT_API + "/v1/drafts/" + encodeURIComponent(session.id),
    { method: "GET", headers: { Authorization: "Bearer " + session.token, Accept: "application/json" }, cache: "no-store" }
  );
  let result = {};
  try { result = await response.json(); } catch (error) {}
  if (!response.ok || !result?.ok || !result?.draft?.id) return { status: "unknown" };
  const remoteFingerprint = JSON.stringify(tacDraftStableValue({
    current_step_key: result.draft.current_step_key || "portada",
    configuration: result.draft.configuration || {}
  }));
  const attemptedFingerprint = JSON.stringify(tacDraftStableValue({
    current_step_key: currentStepKey,
    configuration
  }));
  if (remoteFingerprint === attemptedFingerprint) {
    session.revision = Number(result.draft.revision || session.revision);
    session.material_version = Number(result.draft.material_version ?? session.material_version ?? 0);
    session.expires_at = result.draft.expires_at || session.expires_at;
    window.tacDraftClient.serverConfiguration = configuration;
    window.tacDraftClient.lastSavedFingerprint = JSON.stringify({ current_step_key: currentStepKey, configuration });
    tacDraftStoreSession(session);
    tacDraftSetSaveState("saved");
    return { status: "adopted" };
  }
  return Number(result.draft.revision || 0) > Number(session.revision || 0)
    ? { status: "conflict" }
    : { status: "retry" };
}


/* ----------------------------------------------------------
   EJECUTAR AUTOSAVE
   ---------------------------------------------------------- */

async function tacDraftFlushSave(
  reason = "manual"
) {

  const client =
    window.tacDraftClient;


  if (!client || (client.session?.access_mode === "prepaid" && window.TACPrepaidAccess?.blocked)) {
    return false;
  }


  if (client.saveState === "conflict") {
    window.TACHydration?.preserveConflict();
    return false;
  }

  if (
    client.hydrationReady !==
      true
  ) {

    return false;

  }


  /*
    Si ya hay un PUT trabajando,
    NO lanzamos otro simultáneo.
  */

  if (
    client.savePromise
  ) {

    client.saveQueued =
      true;


    return client.savePromise;

  }


  client.saveQueued =
    false;


  client.savePromise =
    (
      async () => {

        let session = null;
        let configuration = null;
        let currentStepKey = "portada";

        try {

          session =
            await tacEnsureDraftSession();


          if (
            !session?.id ||
            !session?.token
          ) {

            throw new Error(
              "draft_session_missing"
            );

          }


          configuration =
            tacDraftBuildConfiguration();


          currentStepKey =
            client.currentStepKey ||
            "portada";


          /*
            Fingerprint:

            si nada cambió realmente,
            NO hacemos un PUT inútil.
          */

          const fingerprint =
            JSON.stringify({

              current_step_key:
                currentStepKey,

              configuration

            });


          if (
            fingerprint ===
              client
                .lastSavedFingerprint
          ) {

            tacDraftSetSaveState(
              "saved"
            );


            return true;

          }


          tacDraftSetSaveState(
            "saving"
          );


          const response =
            await tacDraftAuthorizedFetch(session,
              TAC_DRAFT_API +
              "/v1/drafts/" +
              encodeURIComponent(
                session.id
              ),
              {

                method:
                  "PUT",

                headers: {

                  Authorization:
                    "Bearer " +
                    session.token,

                  "Content-Type":
                    "application/json",

                  Accept:
                    "application/json"

                },

                body:
                  JSON.stringify({

                    revision:
                      Number(
                        session.revision
                      ),

                    current_step_key:
                      currentStepKey,

                    configuration

                  })

              }
            );


          let result = {};


          try {

            result =
              await response.json();

          } catch (error) {}


          /* ===============================================
             REVISION CONFLICT

             No sobrescribimos silenciosamente
             otro navegador/pestaña.
             =============================================== */

          if (
            response.status === 409 &&
            result?.error ===
              "revision_conflict"
          ) {

            const reconciled = await tacDraftReconcileSave(
              session,
              configuration,
              currentStepKey
            ).catch(() => ({ status: "unknown" }));

            if (reconciled.status === "adopted") return true;

            tacDraftSetSaveState(
              "conflict",
              { error: "revision_conflict" }
            );


            window.TACHydration?.preserveConflict();
            console.warn(
              "[TAC Draft] ⚠️ Conflicto de revisión. Autosave detenido para proteger el diseño.",
              { error: "revision_conflict" }
            );


            return false;

          }


          if (
            !response.ok ||
            !result?.ok
          ) {

            throw new Error(
              result?.error ||
              (
                "draft_save_" +
                response.status
              )
            );

          }


          /* ===============================================
             ÉXITO
             =============================================== */

          session.revision =
            Number(
              result.draft
                ?.revision ||
              session.revision
            );

          session.material_version = Number(result.draft?.material_version ?? session.material_version ?? 0);


          session.expires_at =
            result.draft
              ?.expires_at ||
            session.expires_at;


          client
            .serverConfiguration =
              configuration;


          client
            .lastSavedFingerprint =
              fingerprint;


          tacDraftStoreSession(
            session
          );


          tacDraftSetSaveState(
            "saved"
          );


          console.log(
            "[TAC Draft] 💾 Guardado · rev",
            session.revision,
            "·",
            currentStepKey,
            "·",
            reason
          );


          return true;


        } catch (
          error
        ) {

          if (session && configuration) {
            const reconciled = await tacDraftReconcileSave(
              session,
              configuration,
              currentStepKey
            ).catch(() => ({ status: "unknown" }));

            if (reconciled.status === "adopted") return true;

            if (reconciled.status === "conflict") {
              tacDraftSetSaveState("conflict", { error: "revision_conflict" });
              window.TACHydration?.preserveConflict();
              return false;
            }
          }

          tacDraftSetSaveState(
            "error",
            error
          );


          console.error(
            "[TAC Draft] ❌ Autosave:",
            error
          );


          /*
            Error temporal:
            dejamos una sola recuperación
            diferida, no un loop agresivo.
          */

          clearTimeout(
            client.retryTimer
          );


          client.retryTimer =
            setTimeout(
              () => {

                if (
                  navigator.onLine &&
                  client.saveState ===
                    "error"
                ) {

                  tacDraftScheduleSave({
                    immediate:
                      true,

                    reason:
                      "retry"
                  });

                }

              },
              3000
            );


          return false;

        }

      }
    )();


  try {

    return await client
      .savePromise;


  } finally {

    client.savePromise =
      null;


    /*
      Si el cliente siguió escribiendo
      mientras guardábamos, hacemos
      inmediatamente el siguiente snapshot.
    */

    if (
      client.saveQueued && client.saveState !== "conflict"
    ) {

      client.saveQueued =
        false;


      tacDraftScheduleSave({
        immediate:
          true,

        reason:
          "queued"
      });

    }

  }

}


/* ----------------------------------------------------------
   DETECTAR CAMBIOS DEL CUSTOMIZER

   Una sola capa global;
   no necesitamos editar 20 inputs uno a uno.
   ---------------------------------------------------------- */

function tacDraftBindAutosaveEvents() {

  if (
    window
      .TAC_DRAFT_AUTOSAVE_BOUND
  ) {

    return;

  }


  window
    .TAC_DRAFT_AUTOSAVE_BOUND =
      true;


  const belongsToCustomizer =
    target => {

      return (
        target instanceof Element &&
        !!target.closest(
          "#customizer-hub"
        ) && !(window.TAC_PREPAID_ACTIVE && target.closest("#tacPrepaidConfirm"))
      );

    };


  document.addEventListener(
    "input",
    event => {

      if (
        !belongsToCustomizer(
          event.target
        )
      ) {

        return;

      }


      tacDraftScheduleSave({
        reason:
          "input"
      });

    },
    false
  );


  document.addEventListener(
    "change",
    event => {

      if (
        !belongsToCustomizer(
          event.target
        )
      ) {

        return;

      }


      tacDraftScheduleSave({
        reason:
          "change"
      });

    },
    false
  );


  /*
    Portadas, AddOns, cantidad de fotos,
    botones YES/NO, navegación, etc.

    El setTimeout deja que primero
    se actualice tacCustomizer.data.
  */

  document.addEventListener(
    "click",
    event => {

      if (
        !belongsToCustomizer(
          event.target
        )
      ) {

        return;

      }

      /*
        Once the canonical prepaid review is visible, navigation, confirmation
        and submit controls are not material draft edits. Persisting those
        clicks would increment revision and manufacture a false stale review.
        Returning to an editable step releases this guard in renderPaso().
      */
      if (
        window.TAC_PREPAID_ACTIVE === true &&
        window.TAC_PREPAID_REVIEW_LOCKED === true
      ) {
        return;
      }


      setTimeout(
        () => {

          if (window.TAC_PREPAID_ACTIVE && window.TAC_PREPAID_REVIEW_LOCKED) return;
          tacDraftScheduleSave({
            reason:
              "click"
          });

        },
        0
      );

    }
  );


  /*
    Si vuelve Internet,
    reintentamos cambios pendientes.
  */

  window.addEventListener(
    "online",
    () => {

      const client =
        window.tacDraftClient;


      if (
        client?.saveState ===
          "dirty" ||
        client?.saveState ===
          "error"
      ) {

        tacDraftScheduleSave({
          immediate:
            true,

          reason:
            "online"
        });

      }

    }
  );

}

tacDraftBindAutosaveEvents();

// Scope authorization pauses to Prepaid worker requests; ordinary drafts retain their transport.
function tacDraftAuthorizedFetch(session, url, options) {
  return window.TACPrepaidAccess ? window.TACPrepaidAccess.fetch(session, url, options) : fetch(url, options);
}
